import { render, staticRenderFns } from "./youGiveMe.vue?vue&type=template&id=18312a09&scoped=true"
import script from "./youGiveMe.vue?vue&type=script&lang=js"
export * from "./youGiveMe.vue?vue&type=script&lang=js"
import style0 from "./youGiveMe.vue?vue&type=style&index=0&id=18312a09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18312a09",
  null
  
)

export default component.exports